module.exports = __webpack_public_path__ + "img/strength_training.b690015f.jpg";